import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Button from '../../../../../1stlog-ui/src/components/Button'

const Wrapper = styled.div``

const ShowSubmitValues = (props) => {
  const { onClick } = props

  return (
    <Wrapper>
      <Button danger onClick={onClick}>
        log current submit values to console
      </Button>
    </Wrapper>
  )
}

export default ShowSubmitValues
